import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  client: {
    // Clerk
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY: z.string().min(1),
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: z.string().min(1),
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: z.string().min(1),
    NEXT_PUBLIC_CLERK_AFTER_SIGN_IN_URL: z.string().min(1),
    NEXT_PUBLIC_CLERK_AFTER_SIGN_UP_URL: z.string().min(1),

    // MongoDB
    NEXT_PUBLIC_SERVER_URL: z.string().url(),
    NEXT_PUBLIC_MONGODB_APP_API_KEY: z.string().min(1),
    NEXT_PUBLIC_MONGODB_APPID: z.string().min(1),

    // Stability & AI
    NEXT_PUBLIC_STABILITY_API_KEY: z.string().min(1),
    NEXT_PUBLIC_LEONARDO_API_KEY: z.string().min(1),
    NEXT_PUBLIC_SEGMIND_API_KEY: z.string().min(1),
    NEXT_PUBLIC_TOOLID_SUPERCHAT: z.string().min(1),
    NEXT_PUBLIC_CLOUDINARY_UPLOAD_PRESET: z.string().min(1),
    NEXT_PUBLIC_CLOUDINARY_API_KEY: z.string().min(1),
    NEXT_PUBLIC_CLOUDINARY_SIGNED_PRESET: z.string().min(1),

    // Intercom
    NEXT_PUBLIC_INTERCOM_APP_ID: z.string().min(1),

    // Cloudinary
    NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME: z.string().min(1),

    // Dodo Payments
    NEXT_PUBLIC_DODO_WEBHOOK_KEY: z.string().min(1),

    // Plan IDs and Credits
    NEXT_PUBLIC_PLAN_FREE_ID: z.string().min(1),
    NEXT_PUBLIC_PLAN_FREE_CREDITS: z.string().min(1),

    NEXT_PUBLIC_CLARITY_PROJECT_ID: z.string().min(1),
    NEXT_PUBLIC_FREE_SUBSCRIPITON_ID: z.string().min(1),

    NEXT_PUBLIC_FAL_API_URL: z.string().url(),
    NEXT_PUBLIC__FREE_SUBSCRIPITON_ID: z.string().min(1),
    NEXT_PUBLIC_CIVITAI_API_KEY: z.string().min(1),
    NEXT_PUBLIC_GROQ_API_KEY: z.string().min(1),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY:
      process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_CLERK_SIGN_IN_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
    NEXT_PUBLIC_CLERK_SIGN_UP_URL: process.env.NEXT_PUBLIC_CLERK_SIGN_UP_URL,
    NEXT_PUBLIC_CLERK_AFTER_SIGN_IN_URL:
      process.env.NEXT_PUBLIC_CLERK_AFTER_SIGN_IN_URL,
    NEXT_PUBLIC_CLERK_AFTER_SIGN_UP_URL:
      process.env.NEXT_PUBLIC_CLERK_AFTER_SIGN_UP_URL,
    NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
    NEXT_PUBLIC_MONGODB_APP_API_KEY:
      process.env.NEXT_PUBLIC_MONGODB_APP_API_KEY,
    NEXT_PUBLIC_MONGODB_APPID: process.env.NEXT_PUBLIC_MONGODB_APPID,
    NEXT_PUBLIC_STABILITY_API_KEY: process.env.NEXT_PUBLIC_STABILITY_API_KEY,
    NEXT_PUBLIC_LEONARDO_API_KEY: process.env.NEXT_PUBLIC_LEONARDO_API_KEY,
    NEXT_PUBLIC_SEGMIND_API_KEY: process.env.NEXT_PUBLIC_SEGMIND_API_KEY,
    NEXT_PUBLIC_TOOLID_SUPERCHAT: process.env.NEXT_PUBLIC_TOOLID_SUPERCHAT,
    NEXT_PUBLIC_INTERCOM_APP_ID: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
    NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME:
      process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME,
    NEXT_PUBLIC_DODO_WEBHOOK_KEY: process.env.NEXT_PUBLIC_DODO_WEBHOOK_KEY,
    NEXT_PUBLIC_PLAN_FREE_ID: process.env.NEXT_PUBLIC_PLAN_FREE_ID,
    NEXT_PUBLIC_CLARITY_PROJECT_ID: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
    NEXT_PUBLIC_FREE_SUBSCRIPITON_ID:
      process.env.NEXT_PUBLIC_FREE_SUBSCRIPITON_ID,
    NEXT_PUBLIC_FAL_API_URL: process.env.NEXT_PUBLIC_FAL_API_URL,
    NEXT_PUBLIC_CLOUDINARY_UPLOAD_PRESET:
      process.env.NEXT_PUBLIC_CLOUDINARY_UPLOAD_PRESET,
    NEXT_PUBLIC_CLOUDINARY_API_KEY: process.env.NEXT_PUBLIC_CLOUDINARY_API_KEY,
    NEXT_PUBLIC_CLOUDINARY_SIGNED_PRESET:
      process.env.NEXT_PUBLIC_CLOUDINARY_SIGNED_PRESET,
    NEXT_PUBLIC_PLAN_FREE_CREDITS: process.env.NEXT_PUBLIC_PLAN_FREE_CREDITS,
    NEXT_PUBLIC__FREE_SUBSCRIPITON_ID:
      process.env.NEXT_PUBLIC__FREE_SUBSCRIPITON_ID,
    NEXT_PUBLIC_CIVITAI_API_KEY: process.env.NEXT_PUBLIC_CIVITAI_API_KEY,
    NEXT_PUBLIC_GROQ_API_KEY: process.env.NEXT_PUBLIC_GROQ_API_KEY,
  },
  skipValidation: process.env.NODE_ENV === "development",
});
